import { useEffect, useState } from 'react'

import { useKeenSlider } from 'keen-slider/react'

import xiajia from '@/assets/images/xiajia.svg'
import GlobalCard from '@/components/GlobalCard'
import { useCustomNavigate } from '@/hooks'
import { IBookListResp } from '@/api'
import { cn, handleDetailViewTrack } from '@/utils'
import Icon from '../Icon'
import { useDebounceFn } from 'ahooks'
import BookCard from '../BookCard'

interface PropsIn {
  className?: string
  data: IBookListResp
  afterOnClick?: () => void
}

const BookListItem = (props: PropsIn) => {
  const { data, className, afterOnClick } = props
  const { customNavigator } = useCustomNavigate()
  const [hideMask, setHideMask] = useState(false)

  const [sliderRef, sliderInstance] = useKeenSlider({
    mode: 'free',
    loop: false,
    slides: {
      perView: 'auto',
      spacing: () => {
        const rootFontSize = document.documentElement.style.fontSize.split('px')[0]

        const remSize = Number((Math.ceil(Number(rootFontSize) * 100) / 100).toFixed(1))

        return remSize * 2.6
      },
    },
    detailsChanged(s) {
      const details = s.track.details
      if (!details) return

      const atEnd = details.progress >= 0.999
      const noOverflow = details.maxIdx === details.minIdx
      setHideMask(atEnd || noOverflow)
    },
  })
  const handleBook = () => {
    const type = data.cmty_type === 1 ? 4 : 5
    handleDetailViewTrack({
      resource_type: type,
      resource_id: data?.cmty_id ?? '',
      resource_tag_id: '',
      cover_from: '',
      resource_genre: '',
    })
    customNavigator(`/detail/content/${data.cmty_type}/${data.cmty_id}`)
  }

  useEffect(() => {
    if (data) {
      sliderInstance.current?.update()
    }
  }, [data])

  const { run: handleResize } = useDebounceFn(
    () => {
      sliderInstance.current?.update()
    },
    { wait: 500 },
  )

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])
  return (
    <>
      {!data.created_at ? (
        <div
          className={cn('mb-[22px] flex h-[284px] w-full flex-col items-center justify-center rounded-[15px] bg-color-white-trans10 p-[30px]')}
          onClick={() => {
            customNavigator('/notFound')
          }}
        >
          <img src={xiajia} alt='' />
          <span className='relative mx-[15px] flex items-center justify-center font-geologica text-[26px] font-normal leading-[34px] text-base-text-color opacity-70'>
            <span className='mr-[15px] inline-block h-[2px] w-[149px] rounded-none bg-gradient-to-r from-white to-transparent'></span>
            Content Removed
            <span className='ml-[15px] inline-block h-[2px] w-[149px] rounded-none bg-gradient-to-l from-white to-transparent'></span>
          </span>
        </div>
      ) : (
        <GlobalCard
          className={cn(className)}
          userData={data}
          extra={
            <div className={cn('flex items-center')}>
              <Icon className={cn('mr-[9px] flex h-[22px] w-[22px] items-center justify-center')} name='HeartSmall'></Icon>
              <span className='font-geologica text-[19px] font-[400] text-color-white-trans40'>{!data.like_num ? 'Like' : data.like_num}</span>
            </div>
          }
          onClick={() => {
            afterOnClick?.()
            handleBook()
          }}
        >
          <>
            <div className={cn('mb-[30px] line-clamp-1 break-words font-geologica text-[30px] font-normal leading-[41px] text-base-text-color')}>
              {data.title}
            </div>
            <div
              className={cn('relative h-[358px] overflow-hidden rounded-[15px] bg-discover-card-content-bg-color p-[30px]')}
              id='bookListContainer'
            >
              <div ref={sliderRef} className={cn('keen-slider !overflow-visible')}>
                {data.items.map((item, index) => {
                  return (
                    <BookCard
                      key={item?.resource_id || index}
                      data={item.resource_data}
                      className={cn('keen-slider__slide flex h-full !min-w-[149px] !max-w-[149px] flex-col')}
                      pictureClassName={cn('mb-[21px] h-[210px] w-full overflow-hidden rounded-[7px]')}
                      infoClassName={cn(
                        'w-full m-0',
                        '[&>span]:line-clamp-2 [&>span]:break-words [&>span]:font-geologica [&>span]:text-[22px] [&>span]:font-normal [&>span]:leading-[34px] [&>span]:text-base-text-color [&>span]:mb-0',
                      )}
                      extra={false}
                    />
                  )
                })}
              </div>
              <div
                className={cn(
                  'pointer-events-none absolute right-0 top-0 h-full w-[75px] rounded-br-[15px] rounded-tr-[15px] bg-discover-card-mask-color transition-opacity duration-300 ease-out',
                  hideMask ? 'opacity-0' : 'opacity-100',
                )}
              ></div>
            </div>
          </>
        </GlobalCard>
      )}
    </>
  )
}

export default BookListItem
